export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-gradient-to-br from-primary-500/10 via-accent-100/40 to-background-100 rounded-2xl p-8 md:p-12 border border-background-200/60">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">随时随地吃瓜</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg">
              吃瓜网站完美适配手机、平板和电脑等所有设备，无需下载安装任何App，打开浏览器即可享受流畅的吃瓜体验。无论你在地铁上、午休时还是被窝里，随时随地追最新最热的吃瓜视频。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <div className="flex items-center gap-2 px-4 py-2 bg-background-50 rounded-lg border border-background-200/60">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-smartphone-line text-primary-500"></i>
                </span>
                <span className="text-sm text-foreground-700">响应式设计，全设备适配</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-background-50 rounded-lg border border-background-200/60">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-speed-line text-primary-500"></i>
                </span>
                <span className="text-sm text-foreground-700">无需下载，即开即看</span>
              </div>
            </div>
          </div>

          <div className="flex-shrink-0">
            <div className="w-64 h-[420px] rounded-2xl overflow-hidden border-4 border-background-200/60 shadow-lg bg-background-50">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20mockup%20showing%20a%20content%20feed%20app%20interface%20with%20warm%20coral%20and%20amber%20design%2C%20clean%20UI%20with%20cards%20and%20thumbnails%2C%20minimalist%20style%2C%20no%20real%20text%2C%20abstract%20geometric%20layout&width=320&height=640&seq=app-mockup-01&orientation=portrait"
                alt="吃瓜网站移动端浏览体验"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}